import { render, staticRenderFns } from "./basicDetails.vue?vue&type=template&id=7c72bf70&"
import script from "./basicDetails.vue?vue&type=script&lang=js&"
export * from "./basicDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports